const API_URL = process.env.REACT_APP_CALLBACK_API_URL || '/api/request';

export async function submitCallback(formData) {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'same-origin',
    body: JSON.stringify(formData),
  });

  if (!response.ok) {
    const error = new Error('Callback request failed');
    error.status = response.status;
    throw error;
  }

  const contentType = response.headers.get('content-type');
  if (contentType && contentType.includes('application/json')) {
    return response.json();
  }

  return null;
}
